import React, { useState } from 'react';
import TopNav from '../../../Components/TopNav';
import Navbar from '../../../Components/Navbar';
import DropdownNav from '../../../Components/DropdownNav';
import './about.css'
import Footer from '../../../Components/Footer';
import Example from '../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const NAAC = () => {
  const [toggle, setToggle] = useState(1)
  const [isOpen, setIsOpen] = useState(false)
  const [joint, setJoint] = useState(false)
  const [hons, setHons] = useState(false)
  const [princpal, setPrincpal] = useState(false)

  function updateToogle(id) {
    setToggle(id)
  }
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='init-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      <div className='Measi-details'>
        <div className='measi-header'>
          <h2>Infrastructure → NAAC</h2>
          <p>The New College infrastructure is one of the biggest & best in Tamil Nadu.</p>
        </div>

        <div className='tab-main'>
          <ul className='tab-details'>
            <li className={toggle === 1 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(1)}>Policies</li>
            <li className={toggle === 2 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(2)}>Certificates</li>
            <li className={toggle === 3 ? "show-tab-title" : 'tab-title'} onClick={() => updateToogle(3)}>SSR</li>
          </ul>


          {/* Tab One Details */}

          <div className={toggle === 1 ? "show-tab-content" : 'tab-content'}>
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}

              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/Maintenance_Policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Maintenance Policy</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/admission_policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Admission Policy</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/research-policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Research Policy</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/student_mentoring_and_counselling_policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>STUDENT MENTORING & COUNSELLING POLICY</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/policy_on_it_infrastructure.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>IT Policy</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/Grievance-Redressal-Policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Grievance Redressal Policy</h3>
                  </a>
                </div>
              </div>
              {/* <div> This is the text format pages
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/Maintenance_Policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>The New College Innovation & Start Up Policy (NCISP)</h3>
                  </a>
                </div>
              </div> */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/teaching-policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Teaching Policy</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/differently-abled-friendly-campus-policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Differently Abled Friendly Campus Policy</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/green-campus-policy.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Green Campus Policy</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/policy-on-celebration-of-days-and-events.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Policy on Celebration of Days and Events</h3>
                  </a>
                </div>
              </div>


            </div>
          </div>


                {/* Second Tab Details */}

          <div className={toggle === 2 ? "show-tab-content" : 'tab-content'}>
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}

              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/images/FIRST%20CYCLE.jpg' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>NAAC 1 st Cycle</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/images/Second%20CYCLE.jpg' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>NAAC 2nd Cycle</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/Certificate%20-%20NAAC-3rd%20cycle.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>NAAC-3rd cycle</h3>
                  </a>
                </div>
              </div>
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/NAAC4thcycle.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>NAAC-4th Cycle</h3>
                  </a>
                </div>
              </div>
            </div>
          </div>



          <div className={toggle === 3  ? "show-tab-content" : 'tab-content'}>
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}

              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/The-New-College-SSR-Report.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Self Study Report</h3>
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}

export default NAAC;
